const dropwelt = {
  namespaced: true,

  state: {
    isShowMindMap: false
  },
  mutations: {
    showMindMap (state) {
      state.isShowMindMap = true
    },
    handleMindMap (state) {
      state.isShowMindMap = !state.isShowMindMap
    },
    closeMindMap (state) {
      state.isShowMindMap = false
    }
  },
  actions: {}
}
export default dropwelt
